import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.auth;

export const authErrorsSelector = createSelector(getState, (state) => state.errors);

export const isLoadingSigninSelector = createSelector(getState, (state) => state.isLoadingSignin);
export const isLoadingSignupSelector = createSelector(getState, (state) => state.isLoadingSignup);

export const recoveryPasswordSelector = createSelector(getState, (state) => state.recoveryPassword);
export const isLoadingRecoveryPasswordSelector = createSelector(
  getState,
  (state) => state.isLoadingRecoveryPassword,
);

export const resetPasswordSelector = createSelector(getState, (state) => state.resetPassword);
export const isLoadingResetPasswordSelector = createSelector(
  getState,
  (state) => state.isLoadingResetPassword,
);
